import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0d5b7eb4&scoped=true"
import script from "./composition.js?vue&type=script&lang=js&external"
export * from "./composition.js?vue&type=script&lang=js&external"
import style0 from "./index.vue?vue&type=style&index=0&id=0d5b7eb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5b7eb4",
  null
  
)

export default component.exports